import styles from "./index.module.css";
import styles2 from "../ForgotPin/index.module.css";
import Button from "../../components/ButtonV2";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../../yup";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { useEffect, useState } from "react";
import {
  useVerifyAccountMutation,
  useVerifyPinMutation,
  useUpdateStagesMutation,
  useLazyGetUserFlowQuery,
} from "../../services/api";
import { useSearchParams } from "react-router-dom";
import { setUserLogin } from "../../store/reducers/loginReducer";
import { clsx } from "clsx";
import { setStage } from "../../store/reducers/stageReducer";
import img from "../../assets/images/InceptionFinicallyLogo.png";
import { setUserFolderId } from "../../store/reducers/usersReducer";
import useStep from "../../hooks/useStep";
import { showNotification } from "../../services/showNotification";
import { toggleSubmission } from "../../store/reducers/tileReducer";
import { setPermission } from "../../store/reducers/permissionReducer";
import { setUserFlow } from "../../store/reducers/userFlowReducer";
import { tracker } from "../../services/mixpanel";

const LoginForm = ({
  setIsSolarId,
}: {
  setIsSolarId?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const { setStepFunc } = useStep();

  const dispatch = useAppDispatch();
  const uniqueId = useAppSelector((state) => state.users.uniqueId || "");
  const verifyUserData = useAppSelector((state) => state.login || {});

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id") ?? "";
  const url = window.location.href;
  const urlUniqueId = url.split("/").pop();
  const zohoId: string = id ? id : verifyUserData.zohoCustomerId;

  const [result, { data, isLoading: loading }] = useVerifyAccountMutation();
  const [updateStage, { isLoading: loginLoading }] = useUpdateStagesMutation();
  const [mutate, { isLoading, isError: verifyPinError }] =
    useVerifyPinMutation();

  const [isError, setIsError] = useState("");
  const [pinError, setPinError] = useState("");
  const [loginAttempt, setLoginAttempt] = useState(0);
  const [errorTrue, setErrorTrue] = useState(false);
  const [zohoCustomerId, setZohoCustomerId] = useState(zohoId);
  const [firstName, setFirstName] = useState(verifyUserData?.firstName || "");
  const [LastName, setLastName] = useState(verifyUserData?.lastName || "");

  const setPermissionState = (user: IPurlUser) => {
    if (!user) return;
    const permission = {
      contactGroup: user?.Contact_Group || "OTHER",
      // contactGroup: "AmpVantage Energy",
      // contactGroup: "OTHER",
    };
    localStorage.setItem("permission", JSON.stringify(permission));
    dispatch(setPermission(permission));
  };

  const [triggerUserFlow, { data: userFlowData }] = useLazyGetUserFlowQuery();

  const onSubmit = async (values: any) => {
    values.zohoId = zohoCustomerId;
    tracker.verifyAccount.formSubmit();
    try {
      const data = (await mutate(values)) as Response<any>;
      if (data?.error?.status == 400) {
        throw new Error("invalid pin");
      }
      const folderId =
        data.data.data.driveData.purlDriveLink ??
        data.data.data.driveData.GDriveID;
      localStorage.setItem("folderId", folderId);
      dispatch(setUserFolderId(folderId));

      if (data.error) {
        const loginAttempt = data.error.data.data.loginAttempt;
        setPinError(data.error.data.message);
        setErrorTrue(true);
        setLoginAttempt(loginAttempt);
        setTimeout(() => {
          setPinError("");
        }, 3000);
      } else {
        const { user, token, stageData, purlUser } = data.data.data;
        const role = user.role;

        const userWithContactGroupAndEmail = {
          ...user,
          Contact_Group: purlUser?.Contact_Group,
          email: purlUser?.Email,
        };
        const newStages = {
          videoComplete: stageData.videoComplete,
          purlLoginComplete: stageData.purlLoginComplete,
          purlInviteSent: stageData.purlInviteSent,
          presentationComplete: stageData.presentationComplete,
          benefitCalculatorComplete: stageData.benefitCalculatorComplete,
          cpaCallComplete: stageData.cpaCallComplete,
          softCommitComplete: stageData.softCommitComplete,
          entityInformationCollected: stageData.entityInformationCollected,
          purlNdaChecked: stageData.purlNdaChecked,
          zohoCustomerId: stageData.zohoCustomerId,
          billOfSaleSignedDate: stageData.billOfSaleSignedDate ?? null,
          zohoTrancheId: stageData.zohoTrancheId ?? null,
        };
        dispatch(setStage(newStages));
        localStorage.setItem("token", token);
        localStorage.setItem(
          "user",
          JSON.stringify(userWithContactGroupAndEmail)
        );
        dispatch(setUserLogin(userWithContactGroupAndEmail));

        try {
          const response = await triggerUserFlow({
            contactGroup: userWithContactGroupAndEmail?.Contact_Group ?? "",
            role: userWithContactGroupAndEmail.role ?? "",
          });
          if (response?.data) {
            dispatch(
              setUserFlow({
                contactGroup: response.data?.data.contactGroup || "",
                role: response.data?.data.rolePermissions
                  ? Object.keys(response.data.data.rolePermissions)[0]
                  : verifyUserData.role,
                rolePermissions: response.data?.data.rolePermissions || {},
              })
            );
          }
        } catch (error: any) {
          dispatch(
            setUserFlow({
              contactGroup: "",
              role: "",
              rolePermissions: {},
            })
          );
        }

        const newStateData = {
          ...stageData,
          purlLoginComplete: true,
        };
        const updatedStage = await updateStage({
          zohoId: zohoCustomerId,
          key: "purlLoginComplete",
        });
        localStorage.setItem("newStateData", JSON.stringify(newStateData));
        dispatch(setStage(newStateData));
        if (stageData.cpaCallComplete) {
          localStorage.setItem("tile2", JSON.stringify("tile2"));
          dispatch(toggleSubmission({ component: "tile2" }));
        }
        if (stageData.softCommitComplete) {
          localStorage.setItem("tile5", JSON.stringify("tile5"));
          dispatch(toggleSubmission({ component: "tile5" }));
        }
        const step = setStepFunc(newStateData);
        setPermissionState(purlUser);
      }
      // if (role == "CUSTOMER" && purlNdaChecked == "") {
      //   localStorage.setItem("token", data.data.data.token);
      //   dispatch(setUserLogin(data.data.data.user));
      // } else {
      //   localStorage.setItem("token", data.data.data.token);
      //   dispatch(setUserLogin(data.data.data.user));
      //   dispatch(nextStep());
      // }
    } catch (err: any) {
      showNotification("error", "invalid pin");
      console.log(err);
    }
  };

  const getResponse = async () => {
    if (uniqueId == "") {
      try {
        if (!zohoId && !urlUniqueId) {
          setIsError("Invalid Url");
          return;
        }
        const payload: any = zohoId ? zohoId : urlUniqueId;
        tracker.verifyAccount.pageView(payload);
        const data = (await result(payload)) as Response<VerifyId>;
        if (data?.error?.data.message) {
          throw new Error(data?.error.data.message);
        }
        setFirstName(data.data.data.firstName);
        setLastName(data.data.data.lastName);
        setZohoCustomerId(data.data.data.zohoCustomerId);
        tracker.verifyAccount.identify(data.data.data.zohoCustomerId);
        // console.log("Data coming from zoho is: ", data.data.data);

        setIsSolarId && setIsSolarId((prev) => !prev);
        localStorage.setItem("solarId", data.data.data.solarStudyId);
        if (data.error) {
          localStorage.clear();
          setIsError(data.error.data.message);
        }
      } catch (err: any) {
        if (
          err.toString() ===
          "Error: This account does not have access to this tool. Please reach out to your Inception Financial representative with any questions."
        ) {
          setIsError(
            "This account does not have access to this tool. Please reach out to your Inception Financial representative with any questions."
          );
        } else {
          setIsError("Invalid Customer Id");
        }
      }
    }
  };

  useEffect(() => {
    getResponse();
  }, []);

  useEffect(() => {
    if (loginAttempt >= 3) {
      window.location.href = ` ${
        urlUniqueId ? `/forgot-pin/${urlUniqueId}` : `/forgot-pin?id=${zohoId}`
      } `;
    }
  }, [loginAttempt, zohoId]);

  return (
    <div className={`${styles.container} md:flex justify-center`}>
      <div className=" flex justify-start px-10 pb-20 absolute top-0 left-0">
        <a href="https://www.inception.financial/" target="_blank">
          <img src={img} alt="" className={`${styles.image}`} />
        </a>
      </div>
      {isError ? (
        <p className="text-red-500 text-[38px] sm:text-[35px] mb-[65px] w-[100%] font-bold text-center flex items-center justify-center">
          {isError}
        </p>
      ) : !loading && !loginLoading ? (
        <div className="w-full">
          <div className="w-full ">
            <div className="mb-20">
              <h2 className={styles.heading}>
                Hi, <span className={styles.head1}> {firstName}</span>{" "}
                {LastName}
              </h2>
              <div className="w-full ">
                <form
                  className={clsx(
                    errorTrue && styles.shakeInput,
                    `flex w-full items-center justify-center relative`
                  )}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div
                    className={clsx(styles.inputBox, "flex items-center pl-1")}
                  >
                    <input
                      className={clsx(styles2.input, "w-full font-raleway")}
                      placeholder="PIN _ _ _ _"
                      {...register("pin")}
                      name="pin"
                      type="number"
                      autoComplete="off"
                    />
                  </div>

                  <div className="flex justify-center md:block ">
                    <Button title="SUBMIT" isLoading={isLoading} />
                  </div>
                </form>
                <div className="flex justify-center">
                  {" "}
                  {pinError && (
                    <p className="text-red-600 font-bold text-[12px] sm:text-[15px]">
                      {pinError}
                    </p>
                  )}
                  {errors.pin && (
                    <p className="text-red-600 font-bold text-[12px] sm:text-[15px]">
                      {errors.pin?.message}
                    </p>
                  )}
                </div>
                <a
                  href={` ${
                    urlUniqueId
                      ? `/forgot-pin/${urlUniqueId}`
                      : `/forgot-pin?id=${zohoId}`
                  } `}
                  className="text-[#54d19f] font-light mt-[10px] underline w-full flex items-center justify-center text-[16px] sm:text-[16px]"
                >
                  Forgot your PIN?
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="realtive w-[100%] mb-10  inset-0 flex items-center justify-center">
          <svg
            aria-hidden="true"
            className="w-[60px] h-[60px] text-gray-200 animate-spin dark:text-gray-600 fill-[#55b76c]"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
